import React, { useState } from "react";
import { Box, Button, Menu, MenuItem, Typography } from "@mui/material";
import { downloadICS } from "../../../../../utils/downloadCalenderICS";
import { formatInTimeZone } from "date-fns-tz";
import {
	INVITATION_OCCASION,
	INVITATION_TYPES,
	Invitations
} from "../../../../../store/services/invitations/dto/invitations.dto";
import { Google, InsertInvitation } from "@mui/icons-material";

const getOccasionType = (data: Invitations, isEng: boolean) => {
	switch (data?.occasion) {
		case INVITATION_OCCASION.ENGAGEMENT: {
			return isEng ? "Engagement" : "خِطبه";
		}
		case INVITATION_OCCASION.KATB_KTAB: {
			return isEng ? "Akd Karaan" : "عقد قران";
		}
		default: {
			return isEng ? "Wedding" : "زِفاف";
		}
	}
};

const SaveTheDateBtn = ({ canEdit, data, btnText }: { canEdit: boolean; data: Invitations; btnText: string }) => {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		if (canEdit || data.type === INVITATION_TYPES.TEMPLATE) {
			return event.preventDefault();
		}
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};
	const handleSaveToGoogleCalender = () => {
		const startDate = new Date(data.wedding_date);
		const endDate = new Date(startDate.getTime() + 2 * 60 * 60 * 1000); // 2 hrs later
		const googleStart = formatInTimeZone(startDate, "UTC", "yyyyMMdd'T'HHmmss'Z'");
		const googleEnd = formatInTimeZone(endDate, "UTC", "yyyyMMdd'T'HHmmss'Z'");
		const occasionType = getOccasionType(data, data.language === "EN");
		const title =
			data?.language === "EN"
				? `${data.groom_name} & ${data.bride_name}'s ${occasionType} invitation`
				: ` دعوه ${occasionType} ${data.groom_name} و ${data.bride_name}`;
		const googleUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(
			`${title}`
		)}&dates=${googleStart}/${googleEnd}&location=${encodeURIComponent(
			data.wedding_location_text
		)}&details=${encodeURIComponent(`Invitation Link: ${window.location.origin}/weddingInvitation/${data._id}` || "")}`;
		window.open(googleUrl, "_blank");
	};

	const handleDownloadICS = () => {
		const startDate = new Date(data.wedding_date);
		const endDate = new Date(startDate.getTime() + 2 * 60 * 60 * 1000); // 2 hrs later
		const occasionType = getOccasionType(data, data.language === "EN");
		const title =
			data?.language === "EN"
				? `${data.groom_name} & ${data.bride_name}'s ${occasionType} invitation`
				: ` دعوه ${occasionType} ${data.groom_name} و ${data.bride_name}`;
		downloadICS({
			id: data._id,
			title: `${title}`,
			location: data.wedding_location_text,
			startDate,
			description: `${`Invitation Link: ${window.location.origin}/weddingInvitation/${data._id}` || ""}`,
			endDate
		});
	};

	return (
		<>
			<Button
				id="save-btn"
				aria-controls={open ? "save-btn" : undefined}
				aria-haspopup="true"
				aria-expanded={open ? "true" : undefined}
				onClick={handleClick}
			>
				{btnText}
			</Button>
			<Menu
				id="save-btn"
				aria-labelledby="save-btn"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "top",
					horizontal: "left"
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "left"
				}}
			>
				<MenuItem onClick={handleSaveToGoogleCalender}>
					<Box display={"flex"} gap={1}>
						<Google />
						<Typography>Google Calender</Typography>
					</Box>
				</MenuItem>
				<MenuItem onClick={handleDownloadICS}>
					<Box display={"flex"} gap={1}>
						<InsertInvitation />
						<Typography>Calender</Typography>
					</Box>
				</MenuItem>
			</Menu>
		</>
	);
};

export default SaveTheDateBtn;
